import { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { HeaderWeb } from "senac-components";
import { useAppDispatch } from "../store";
import { authenticateSso, signinSso } from "../store/reducers/userSlice";

export const Wsso = () => {
  const { organization, login, token, path } = useParams();
  const query_params = useLocation();
  const dispatch = useAppDispatch();
  const ran = useRef(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(query_params.search);
    let path = queryParams.get("path") || "";

    // Converter paths antigos para novos
    if (path.startsWith("/edition/")) {
      const isbn = path.replace("/edition/", "");
      path = `/search/metadata?q=${isbn}`;
    } else if (path === "") {
      path = "/inicio";
    }

    if (organization && login && token && !ran.current) {
      dispatch(authenticateSso({ login, organization, token, path: path }));
      ran.current = true;
    }
  }, []);

  return (
    <>
      <HeaderWeb />
    </>
  );
};
